export interface DiscoveredComponent {
    element: Element;
    componentName: string;
    data: unknown;
}

const SELECTOR = '[data-react-component]';

export const discoverComponents = (): DiscoveredComponent[] => {
    const elements = document.querySelectorAll(SELECTOR);

    return Array.from(elements)
        .map(element => {
            const componentName = element.getAttribute('data-react-component');
            if (!componentName) return null;

            const script = element.querySelector('script[type="application/json"]');
            if (!script?.textContent) return null;

            try {
                const data: unknown = JSON.parse(script.textContent);
                return { element, componentName, data };
            } catch {
                console.warn(
                    `[ComponentFactory] Failed to parse JSON for "${componentName}"`,
                );
                return null;
            }
        })
        .filter((item): item is DiscoveredComponent => item !== null);
};
